"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatchingFiles = exports.generateExtractAction = void 0;
const minimatch_1 = require("minimatch");
const path = require("path");
const stream_utils_1 = require("../../stream-utils");
/**
 * Return false if any exclusion pattern matches,
 * return true if any inclusion pattern matches
 */
function generatePathMatcher(globsInclude, globsExclude) {
    const matchOptions = {
        windowsPathsNoEscape: true,
        optimizationLevel: 0,
    };
    return (filePath) => {
        if (globsExclude.some((glob) => (0, minimatch_1.minimatch)(filePath, glob, matchOptions))) {
            return false;
        }
        return globsInclude.some((glob) => (0, minimatch_1.minimatch)(filePath, glob, matchOptions));
    };
}
function generateExtractAction(globsInclude, globsExclude) {
    return {
        actionName: "find-files-by-pattern",
        filePathMatches: generatePathMatcher(globsInclude, globsExclude),
        callback: (dataStream, streamSize) => (0, stream_utils_1.streamToString)(dataStream, streamSize, "base64"),
    };
}
exports.generateExtractAction = generateExtractAction;
function getMatchingFiles(extractedLayers) {
    const manifestFiles = [];
    for (const filePath of Object.keys(extractedLayers)) {
        for (const actionName of Object.keys(extractedLayers[filePath])) {
            if (actionName !== "find-files-by-pattern") {
                continue;
            }
            if (typeof extractedLayers[filePath][actionName] !== "string") {
                throw new Error("expected a string");
            }
            manifestFiles.push({
                name: path.basename(filePath),
                path: path.dirname(filePath),
                contents: extractedLayers[filePath][actionName],
            });
        }
    }
    return manifestFiles;
}
exports.getMatchingFiles = getMatchingFiles;
//# sourceMappingURL=static.js.map